var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.72 96.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1-simulation{stroke-miterlimit:10;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M321.64,922H301.22a1.85,1.85,0,1,1,0-3.69h18.57V899.68a1.85,1.85,0,0,1,3.7,0v20.43A1.84,1.84,0,0,1,321.64,922ZM250,922H229.61a1.84,1.84,0,0,1-1.84-1.84V899.68a1.85,1.85,0,1,1,3.69,0v18.58H250a1.85,1.85,0,1,1,0,3.69Zm71.6-71.6a1.85,1.85,0,0,1-1.85-1.85V829.92H301.22a1.85,1.85,0,1,1,0-3.69h20.42a1.85,1.85,0,0,1,1.85,1.85V848.5A1.85,1.85,0,0,1,321.64,850.35Zm-92,0a1.84,1.84,0,0,1-1.84-1.85V828.08a1.84,1.84,0,0,1,1.84-1.85H250a1.85,1.85,0,1,1,0,3.69H231.46V848.5A1.85,1.85,0,0,1,229.61,850.35Z",
    transform: "translate(-227.27 -825.73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M275.57,901.42a1.93,1.93,0,0,1-.92-.25l-22.06-12.71a1.85,1.85,0,0,1-.92-1.6V861.32a1.87,1.87,0,0,1,.92-1.6L274.65,847a1.86,1.86,0,0,1,1.84,0l22.17,12.71a1.86,1.86,0,0,1,.93,1.6v25.54a1.86,1.86,0,0,1-.93,1.6l-22.17,12.71A1.77,1.77,0,0,1,275.57,901.42Zm-20.21-15.63,20.22,11.65,20.31-11.65v-23.4l-20.31-11.65-20.22,11.65Z",
    transform: "translate(-227.27 -825.73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M275.57,876a2,2,0,0,1-.93-.25l-22-12.83a1.85,1.85,0,1,1,1.86-3.19l22.05,12.82a1.85,1.85,0,0,1-.93,3.45Z",
    transform: "translate(-227.27 -825.73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M275.58,876a1.88,1.88,0,0,1-1.61-.93,1.85,1.85,0,0,1,.68-2.52l22.16-12.82a1.86,1.86,0,0,1,2.53.67,1.84,1.84,0,0,1-.68,2.52L276.5,875.75A1.93,1.93,0,0,1,275.58,876Z",
    transform: "translate(-227.27 -825.73)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M275.57,901.42a1.84,1.84,0,0,1-1.84-1.85V874.15a1.85,1.85,0,1,1,3.69,0v25.42A1.85,1.85,0,0,1,275.57,901.42Z",
    transform: "translate(-227.27 -825.73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M241,876H229.61a1.85,1.85,0,0,1,0-3.69H241a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M241,866.32h-4.13a1.85,1.85,0,0,1,0-3.69H241a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M241,885.55h-4.13a1.85,1.85,0,0,1,0-3.69H241a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M321.64,876H310.12a1.85,1.85,0,0,1,0-3.69h11.52a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M314.36,866.32h-4.24a1.85,1.85,0,0,1,0-3.69h4.24a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-simulation",
    d: "M314.36,885.55h-4.24a1.85,1.85,0,0,1,0-3.69h4.24a1.85,1.85,0,1,1,0,3.69Z",
    transform: "translate(-227.27 -825.73)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/Simulation.3989f60660d6ab571f7e4dec0a066bc0.svg";
export { ForwardRef as ReactComponent };